import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import { Typography, Grid, Tooltip } from '@material-ui/core';
import { Button, DataAction, Modals } from 'ecrion-components';
import Modal from '../../../modal';
import Icon from '../../../core/Icon';
var iconStyle = {
  lineHeight: '16px',
  fontSize: '.875rem',
  paddingRight: 15,
  paddingLeft: 5
};
/**@type {import('../types').DataType<import('./types').EmailTrackerDataModel>} */

var EMAIL_TRACKING_DATA_TYPE = {
  data: {
    dataKey: 'trackers',
    url: '/backend/trackers2',
    createItemUrl: '/backend/trackers2',
    itemUrl: '/backend/trackers2?id={id}',
    deleteItemUrl: '/backend/trackers2?id={id}',
    idKeyProp: 'TrackerId',
    onAfterResponse: function onAfterResponse(options, request, body) {
      if (request.type === 'loadView') {
        return {
          Data: body.Data.map(function (i) {
            return _objectSpread({}, i, {
              disabled: i.URLs == options.dataProps.defaultDomain ? true : false
            });
          })
        };
      }
    }
  },
  placeholders: {
    label: function label(data) {
      return data.TrackerId;
    },
    type: function type() {
      return 'Tracking';
    },
    icon: function icon() {
      return 'email';
    }
  },
  columns: [{
    id: 'Domain',
    formatter: function NameFormatter(_ref) {
      var data = _ref.data;
      return React.createElement(React.Fragment, null, React.createElement(Grid, {
        container: true,
        direction: "row",
        justify: "flex-start",
        alignItems: "center"
      }, React.createElement(Grid, {
        item: true
      }, data.URLs), data.disabled ? React.createElement(React.Fragment, null, React.createElement(Grid, {
        item: true
      }, React.createElement(Icon, {
        style: iconStyle,
        type: "warning",
        label: "Tracker cannot be edited because it is used to test Lead Generation Form"
      }))) : null));
    },
    inMemorySort: false,
    serverSort: true
  }, {
    id: 'Tracker ID',
    inMemorySort: false,
    formatter: function NameFormatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(React.Fragment, null, React.createElement(Grid, {
        container: true,
        direction: "row",
        justify: "flex-start",
        alignItems: "center"
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(Typography, null, data.TrackerId)), React.createElement(Grid, {
        item: true
      }, React.createElement(Button, {
        variant: "text",
        disabled: data.disabled,
        onClick: function onClick() {
          Modal.open({
            type: Modal.TYPES.TRACKER_EMAIL_CODE,
            props: {
              WebsiteTrackingCode: data.WebsiteTrackingCode
            }
          });
        }
      }, "Get Tracking Code"))));
    }
  }, {
    id: 'Anonymous Users',
    formatter: function formatter(_ref3) {
      var data = _ref3.data;
      return data.AnonymousUsersCount;
    },
    inMemorySort: false,
    width: {
      xs: '20%'
    }
  }, {
    id: 'Tracked Users',
    formatter: function formatter(_ref4) {
      var data = _ref4.data;
      return data.TrackedUsersCount;
    },
    inMemorySort: false,
    width: {
      xs: '20%'
    }
  }],
  contextMenu: [{
    type: 'noOptions',
    label: 'No options available',
    hidden: function hidden(item) {
      return item && !item.disabled;
    }
  }, {
    type: 'edit',
    hidden: function hidden(item) {
      return item && item.disabled;
    },
    onClick: function onClick(e, item) {
      return Modals.open({
        type: Modals.TYPES.TRACKER_EMAIL_SETTINGS,
        props: {
          id: item.TrackerId
        }
      });
    }
  }, {
    type: 'separator',
    hidden: function hidden(item) {
      return item && item.disabled;
    }
  }, {
    type: 'delete',
    hidden: function hidden(item) {
      return item && item.disabled;
    },
    onClick: function onClick(e, item) {
      DataAction.item({
        dataType: 'tracking',
        id: item.TrackerId
      }).delete({
        useConfirmation: true,
        message: 'Are you sure you want to stop tracking ' + item.URLs + ' ?',
        title: 'Stop Tracking',
        submitLabel: 'Stop',
        submittingLabel: 'Stoping'
      });
    }
  }]
};
export default EMAIL_TRACKING_DATA_TYPE;